import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar1.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">

            <p className="home-about-body">
              My name is <b className="purple">Seah Hong</b>, and I'm a Junior at Lambert High School in Georgia, USA.
              <br />
              <br />I have been passionate about Computer Science since middle school, with particular interest in 
              <i>
                <b className="purple"> algorithms, artificial intelligence (AI), and game development.
                </b>
              </i>
              <br />
              <br />
              I have practical experience in
              <i>
                <b className="purple">{" "}Javascript, Java, and Python, </b> as well as front-end website development using
               {" "}
                <b className="purple">
                  HTML and CSS.
                </b>
              </i>
              <br />
              <br />
              I am applying to the GHP to {" "}
              <b className="purple">significantly deepen my understanding of these subjects, collaborate with highly motivated peers</b>, and
              <i>
                <b className="purple">
                  {" "}
                  challenge myself
                </b>

              </i>
              {" "} with advanced, real-world projects.


            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar1" />
            </Tilt>
          </Col>
        </Row>

      </Container>
    </Container>
  );
}
export default Home2;
